import { render, staticRenderFns } from "./DeliveryDetailSection.vue?vue&type=template&id=85a64b7e&scoped=true&"
import script from "./DeliveryDetailSection.vue?vue&type=script&lang=js&"
export * from "./DeliveryDetailSection.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDetailSection.vue?vue&type=style&index=0&id=85a64b7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a64b7e",
  null
  
)

export default component.exports